import MentionAvatar from '../Common/Mentions/MentionAvatar'
import styles from './CustomFieldTeamIcon.module.scss'

// The mention chip pins its glyph to 16px; the SVG's own 24px makes the row taller.
export const TEAM_GLYPH_PX = 16

interface IProps {
  name: string
}

// The team glyph as a list-option icon, in the same box as the people avatars beside it.
const CustomFieldTeamIcon = ({ name }: IProps) => (
  <span className={styles.icon}>
    <MentionAvatar avatar="team" name={name} size={TEAM_GLYPH_PX} />
  </span>
)

export default CustomFieldTeamIcon
